import Component from '../core/Component';
import $ from 'jquery';

export default class menuToggle extends Component {

    constructor($element) {
        super($element);
        this.$toggle = $('.menu-toggle');
        this.$nav = $('.header__nav');
    }

    prepare() {
        var self = this
        var $nav = this.$nav;
        var $toggle = this.$toggle;

        this.setViewportHeight()

        $(window).on('resize', function () {
            self.setViewportHeight()
        });

        // pozice callUpBox na mobilu
        let callUpBox = document.querySelector('.callUp')
        if (callUpBox) {
            callUpBox.style.bottom = "-" + callUpBox.offsetHeight + 'px';
        }

        $toggle.click(function(){
           $toggle.find('.menu-toggle__hamburger').toggleClass('open');
           $nav.toggleClass('active');
           $('body').toggleClass('fix-body');
        });
    }
    setViewportHeight() {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        let homepageHeader = document.querySelector('.homepage-header')
        if (homepageHeader) {
            homepageHeader.style.setProperty('--vh', `${vh}px`)
        }
    }
}



// WEBPACK FOOTER //
// ./components/MenuToggle.js